import { z } from "zod";

import { Logger } from "@abacus/common";
import { contractId } from "@abacus/ows-contract-client/zod";

export const sapSyncContractsJobConfigSchema = z
  .object({
    logger: (z.unknown() as z.ZodType<Logger>).optional(),
    resync: z.coerce.boolean().default(false),
  })
  .optional();

export const sapSyncContractsJobDataSchema: z.ZodType<{
  contractIds: number[];
}> = z.object({
  contractIds: z.array(contractId),
});
